import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './app/Layout/Layout.jsx';
import { Home, Dashboard, Shops, ShopDetail, Embed, CampaignMap } from './pages/index.js';
import { ParentBridge } from './components/ParentBridge/ParentBridge.jsx';
import { ROUTES } from './utils/index.js';

function App() {
  return (
    <BrowserRouter>
      {/* Always-on listener for parent postMessages (campaignId/appHost/lid
          changes) — survives route changes so live updates are applied. */}
      <ParentBridge />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="embed" element={<Embed />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="shops" element={<Shops />} />
          <Route path="shops/:id" element={<ShopDetail />} />
          <Route path="campaign/:nacCampaignId" element={<CampaignMap />} />
          <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
